exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-active{\n  -webkit-box-shadow:0px 0px 6px 1px rgba(var(--vs-primary), 0.6);\n          box-shadow:0px 0px 6px 1px rgba(var(--vs-primary), 0.6)\n}\n.header-label{\n  border-radius:4px\n}\n.header-open{\n  background-color:#f6f6f6\n}\n.header-children{\n  min-width:215px;\n  top:100%;\n  border-radius:4px;\n  z-index:1\n}\n.header-children.dd-right{\n  right:1rem\n}\n.theme-dark .header-open{\n  background-color:#262c49\n}", ""]);

// exports
